import Hammer from 'hammerjs';
// const TouchVelocity =
export default class {
	addListeners = () => {
		this.hammer.on('panstart', this.handleDragStart), this.hammer.on('pan', this.handleDrag);
	};
	removeListeners = () => {
		this.hammer && (this.hammer.off('panstart', this.handleDragStart), this.hammer.off('pan', this.handleDrag));
	};
	getDifference = (a, b) => Math.abs(a - b);
	handleDragStart = (a) => {
		this.velocityTicker && cancelAnimationFrame(this.velocityTicker),
			(this.allowVelocity = !0),
			(this.touch.x = a.center.x),
			(this.touch.y = a.center.y),
			(this.touch.movement = 0),
			this.callbacks.touchstart && this.callbacks.touchstart(this.touch, a);
	};
	handleDrag = (a) => {
		if ((a.isFinal && this.handleDragEnd(a), a.center.x === 0 && a.center.y === 0)) return;
		let b = this.getDifference(this.touch.x, a.center.x);
		(this.v = a.velocityX),
			this.v === 0 && (this.t && (clearTimeout(this.t), (this.t = null)), (this.velocityX = 0)),
			Math.abs(this.velocityX) > Math.abs(a.velocityX)
				? this.isSlowingDownDrag || ((this.isSlowingDownDrag = !0), (this.velocityX = this.v))
				: ((this.isSlowingDownDrag = !1),
				  this.t && (clearTimeout(this.t), (this.t = null)),
				  (this.velocityX = a.velocityX)),
			this.touch.x < a.center.x || (b = -b),
			(this.touch.movement = b),
			(this.touch.x = a.center.x),
			(this.touch.y = a.center.y),
			this.callbacks.touchmove && this.callbacks.touchmove(this.touch, a);
	};
	handleDragEnd = (a) => {
		(this.touch.x = a.center.x),
			(this.touch.y = a.center.y),
			this.callbacks.touchend && this.callbacks.touchend(this.touch, a),
			this.t && (clearTimeout(this.t), (this.t = null)),
			(this.isRunning = !0),
			(this.velocityTicker = requestAnimationFrame(this.handleVelocityTick));
	};
	handleVelocityTick = () => {
		if (this.allowVelocity === !0) {
			this.velocityX *= 0.9;
			var a = this.velocityX * 15;
			(this.touch.movement = a),
				(this.touch.x += a),
				this.callbacks.touchmove && this.callbacks.touchmove(this.touch),
				Math.abs(this.velocityX) > 0.03
					? (this.velocityTicker = requestAnimationFrame(this.handleVelocityTick))
					: (this.isRunning = !1);
		}
	};
	stopVelocity = () => {
		this.allowVelocity = !1;
	};
	enable = () => {
		this.addListeners();
	};
	disable = () => {
		this.removeListeners();
	};
	kill = () => {
		this.disable(), this.velocityTicker && (clearTimeout(this.velocityTicker), (this.velocityTicker = null));
	};
	constructor(a, b, c) {
		(this.node = a),
			(this.callbacks = b),
			(this.dir = c),
			(this.isSlowingDownDrag = !1),
			(this.allowVelocity = !0),
			(this.touch = {
				x: 0,
				y: 0,
				movement: 0,
			}),
			(this.hammer = new Hammer(this.node)),
			(this.pan = new Hammer.Pan({
				direction: this.dir,
				threshold: 0,
			})),
			this.hammer.add([this.pan]),
			this.enable();
	}
}
